import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

type Props = {
    heading: string,
    to?: string,
    action?: string,
    className?: string,
    id?: string,
}

const TopHeader = ({ heading, to, action, className, id }: Props) => {
    const navigate = useNavigate();
 
    return (
        <>
            <div className='row'>
                <div className='col-sm-6 mt-3'>
                    <h2 className="heading-font head-heading"><span className="header_underline">{heading}</span></h2>
                </div>

                <div className='col-sm-6 rightsidebutton'>
                    <Button className="m-3" id={id} style={{ background: '#0187c4' }} onClick={(e) => { navigate("" + to); }}><i className={"fa m-1 " + className} aria-hidden="true"></i>{action}</Button>
                </div>
            </div>
        </>
    )
}

export default TopHeader;